import React from "react"; // REMOVED useEffect and useRef
import { Container, Button, Row, Col } from "react-bootstrap";
import {
  Shield,
  Users,
  Clock,
  Code2,
  Network,
  Wifi,
  Bug,
  Lock,
  IndianRupee,
  CalendarDays,
  Trophy,
  Zap,
  ArrowRight,
} from "lucide-react";

import BatchSelection from "../../components/updatehackinginternship/BatchSchedule";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

// NOTE: For this component to work in your project, you will need to install the required libraries:
// npm install react-bootstrap bootstrap lucide-react

// NEW StaticHackerBackground component
const StaticHackerBackground = () => (
  <div
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      overflow: "hidden",
      zIndex: 0,
      backgroundColor: "#020402", // Very dark green/black
    }}
  >
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid slice"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        {/* Faint dot grid */}
        <pattern
          id="plexus-grid"
          width="5"
          height="5"
          patternUnits="userSpaceOnUse"
        >
          <circle cx="1" cy="1" r="0.5" fill="rgba(0, 255, 70, 0.05)" />
        </pattern>

        {/* Gradient for the lines */}
        <linearGradient id="plexus-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(0, 255, 70, 0.1)" />
          <stop offset="100%" stopColor="rgba(0, 255, 70, 0.4)" />
        </linearGradient>

        {/* Filter for a subtle glow on nodes */}
        <filter id="node-glow-static">
          <feGaussianBlur stdDeviation="1" result="coloredBlur" />
          <feMerge>
            <feMergeNode in="coloredBlur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {/* Layer 1: Dot grid background */}
      <rect width="100%" height="100%" fill="url(#plexus-grid)" />

      {/* Layer 2: The plexus network lines */}
      <g stroke="url(#plexus-grad)" strokeWidth="0.2">
        {/* A web of interconnected lines */}
        <path d="M 10 10 L 30 40 L 10 90 L 50 50 L 10 10" />
        <path d="M 90 90 L 70 60 L 90 10 L 50 50 L 90 90" />
        <path d="M 30 40 L 50 50 L 70 60" />
        <path d="M 10 90 L 50 50 L 90 10" />
        <path d="M 20 50 L 50 20 L 80 50 L 50 80 L 20 50" />
        <path d="M 50 20 L 30 10 L 70 10 L 50 20" />
        <path d="M 50 80 L 30 90 L 70 90 L 50 80" />
      </g>

      {/* Layer 3: The nodes (dots) */}
      <g fill="#00ff41" filter="url(#node-glow-static)">
        <circle cx="50" cy="50" r="1.5" />
        <circle cx="10" cy="10" r="1" />
        <circle cx="90" cy="90" r="1" />
        <circle cx="10" cy="90" r="1" />
        <circle cx="90" cy="10" r="1" />
        <circle cx="30" cy="40" r="1" />
        <circle cx="70" cy="60" r="1" />
        <circle cx="50" cy="20" r="1.2" />
        <circle cx="50" cy="80" r="1.2" />
        <circle cx="20" cy="50" r="1.2" />
        <circle cx="80" cy="50" r="1.2" />
      </g>
    </svg>
  </div>
);

const ArtisticUnderline = () => (
  <svg
    width="200"
    height="12"
    viewBox="0 0 200 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className=" mt-1 mb-3"
  >
    <path
      d="M2 10.132C32.0124 2.12051 133.223 -4.08843 198 10.132"
      stroke="#EF4444"
      strokeWidth="4"
      strokeLinecap="round"
    />
  </svg>
);

const InternalStyles = () => {
  const styles = `
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

    body {
      font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
        'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
        sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      overflow-x: hidden;
      background-color: #f8f9fa;
    }

    /* New Hero Design */
    .hero-section {
      background-color: #020402; /* Dark background */
      color: #f8f9fa; /* Light text */
      position: relative;
      min-height: 90vh;
      padding: 10px 0;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: left;
    }

    .hero-content {
      position: relative;
      padding-bottom: 50px;
      z-index: 1;
    }

    .hero-content p.text-muted {
        color: #adb5bd !important; /* Lighter text for dark bg */
    }

    .hero-image {
        border-radius: 20px;
        box-shadow: 0 0 40px rgba(0, 255, 70, 0.25); /* Green glow */
        border: 1px solid rgba(0, 255, 70, 0.3); /* Faint green border */
    }
    
    .btn {
      font-weight: 600;
      letter-spacing: 0.5px;
      transition: all 0.3s ease;
      border-radius: 8px;
    }

    .btn-danger {
      background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
      border: none;
      padding: 14px 28px;
      font-size: 1rem;
    }
    .btn-danger .btn-icon {
        transition: transform 0.3s ease;
    }
    .btn-danger:hover {
      background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
      transform: translateY(-3px);
      box-shadow: 0 10px 20px rgba(239, 68, 68, 0.2);
    }
     .btn-danger:hover .btn-icon {
        transform: translateX(4px);
    }
    
    .prize-pools-section {
        margin: 2rem 0;
    }
    
    /* RE-THEMED Prize Cards for Dark Mode */
    .prize-card {
        background-color: rgba(10, 25, 10, 0.7); /* Dark semi-transparent green */
        backdrop-filter: blur(10px);
        border: 1px solid rgba(0, 255, 70, 0.2); /* Faint green border */
        border-radius: 20px;
        padding: 1.25rem;
        transition: all 0.3s ease;
        text-align: center;
    }
    
    .prize-card.first-place {
        transform: scale(1.05);
        border-color: #00ff41; /* Bright green border */
        box-shadow: 0 10px 40px rgba(0, 255, 70, 0.2); /* Green glow */
    }

    .prize-card .prize-rank {
        font-weight: 600;
        color: #adb5bd; /* Light gray */
    }
    .prize-card .prize-amount {
        font-size: 2rem;
        font-weight: 800;
        color: #ffffff; /* White */
        margin: 0.5rem 0;
    }
    .prize-card .prize-amount svg {
        color: #00ff41; /* Make rupee icon green */
    }
    /* End of Prize Card Retheme */

    /* Redesigned Projects Section */
    .projects-section {
        padding: 80px 0;
        background-color: #f8f9fa;
    }
    .project-card {
      background: #ffffff;
      border-radius: 16px;
      border: 1px solid #e9ecef;
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.05);
      overflow: hidden;
      transition: all 0.3s ease-in-out;
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    .project-card:hover {
      transform: translateY(-10px);
      box-shadow: 0 15px 40px rgba(0, 0, 0, 0.1);
      border-color: #ef4444;
    }
    .project-card-header {
      padding: 1.5rem;
      display: flex;
      align-items: center;
      gap: 1rem;
      border-bottom: 1px solid #e9ecef;
    }
    .project-card-header .icon-bg {
      width: 50px;
      height: 50px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 12px;
    }
    .project-card-body {
      padding: 1.5rem;
      flex-grow: 1;
    }
    .project-card-footer {
      padding: 1rem 1.5rem;
      background-color: #f8f9fa;
    }

    @media (max-width: 991.98px) {
       .hero-section {
        padding: 60px 0;
        text-align: center;
       }
       .hero-image-col {
        margin-top: 3rem;
       }
       .prize-card.first-place {
        transform: scale(1);
       }
    }
  `;
  return <style>{styles}</style>;
};

function App() {
  const projects = [
    {
      icon: Code2,
      title: "Web App Penetration Testing",
      desc: "Conduct a full security assessment of a vulnerable web application, identifying OWASP Top 10 vulnerabilities.",
      level: "Advanced",
      badge: "danger",
    },
    {
      icon: Network,
      title: "Network Security Audit",
      desc: "Perform comprehensive network scanning and vulnerability assessment on enterprise-level networks.",
      level: "Intermediate",
      badge: "warning",
    },
    {
      icon: Wifi,
      title: "Wireless Network Attack",
      desc: "Learn to crack WPA2 passwords and secure wireless networks against common, real-world attacks.",
      level: "Beginner",
      badge: "success",
    },
    {
      icon: Bug,
      title: "Malware Analysis",
      desc: "Reverse engineer and analyze malware samples in a safe, sandboxed environment to understand threats.",
      level: "Advanced",
      badge: "danger",
    },
    {
      icon: Shield,
      title: "Social Engineering Campaign",
      desc: "Design and execute ethical phishing campaigns to rigorously test organizational security awareness.",
      level: "Intermediate",
      badge: "warning",
    },
    {
      icon: Lock,
      title: "Cryptography Challenge",
      desc: "Break complex encryption challenges and learn to implement secure cryptographic solutions.",
      level: "Advanced",
      badge: "danger",
    },
  ];

  return (
    <>
      <InternalStyles />
      <div className="app">
        <section className="hero-section" id="home">
          <StaticHackerBackground /> {/* CHANGED */}
          <Container className="hero-content">
            <Row className="align-items-center">
              <Col lg={7} md={12}>
                <h1
                  className="display-5 fw-bold mb-3"
                  style={{ lineHeight: "1.2" }}
                >
                  Launch Your Career in Cybersecurity
                </h1>
                <p className="lead text-muted mb-4">
                  Our 12-week immersive bootcamp provides the hands-on training
                  you need to become a job-ready ethical hacker.
                </p>

                <div className="prize-pools-section">
                  <h2 className="fs-4 fw-bold text-center">
                    Internship Hackathon Prizes
                  </h2>

                  <div className="d-flex justify-content-center">
                    <ArtisticUnderline className="mx-auto" />
                  </div>

                  <Row className="g-3 mt-3 align-items-center justify-content-center">
                    <Col md={4} sm={6}>
                      <div className="prize-card">
                        <Trophy
                          size={28}
                          className="mb-2"
                          style={{ color: "#ffffff" }}
                        />
                        <p className="prize-rank">2nd Place</p>
                        <div className="prize-amount">
                          <IndianRupee size={22} />
                          50,000
                        </div>
                      </div>
                    </Col>
                    <Col md={4} sm={6}>
                      <div className="prize-card first-place">
                        <Trophy
                          size={32}
                          className="mb-2"
                          style={{ color: "#00ff41" }}
                        />
                        <p className="prize-rank">1st Place</p>
                        <div className="prize-amount">
                          <IndianRupee size={28} />
                          1,00,000
                        </div>
                      </div>
                    </Col>
                    <Col md={4} sm={6}>
                      <div className="prize-card">
                        <Trophy
                          size={28}
                          className="mb-2"
                          style={{ color: "#adb5bd" }}
                        />
                        <p className="prize-rank">3rd Place</p>
                        <div className="prize-amount">
                          <IndianRupee size={22} />
                          25,000
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Link to="/course/ethical-hacking-specialization/specialization">
                  <Button variant="danger" size="lg" className="mt-3">
                    Enroll Now & Claim Your Spot{" "}
                    <ArrowRight size={20} className="ms-2 btn-icon" />
                  </Button>
                </Link>
              </Col>

              <Col lg={5} md={12} className="text-center hero-image-col">
                <img
                  src="https://skillsuprise.com/data/course-images/ethical-hacking-3.jpg"
                  alt="Cybersecurity professional working on a laptop"
                  className="img-fluid hero-image"
                />
              </Col>
            </Row>
          </Container>
        </section>

        <BatchSelection />

        {/* Redesigned Projects Section
        <section className="projects-section" id="projects">
          <Container>
            <Row className="mb-5">
              <Col lg={8} className="mx-auto text-center">
                <h2 className="display-5 fw-bold mb-3">Real-World Projects</h2>
                <p className="lead text-muted">
                  Build your portfolio with hands-on security projects.
                </p>
              </Col>
            </Row>
            <Row className="g-4">
              {projects.map((project, index) => {
                const Icon = project.icon;
                return (
                  <Col lg={4} md={6} key={index}>
                    <div className="project-card">
                      <div className="project-card-header">
                        <div className={`icon-bg bg-${project.badge} bg-opacity-10`}>
                            <Icon size={24} className={`text-${project.badge}`} />
                        </div>
                        <h5 className="fw-bold mb-0">{project.title}</h5>
                      </div>
                      <div className="project-card-body">
                        <p className="text-muted mb-0">{project.desc}</p>
                      </div>
                      <div className="project-card-footer">
                        <span className={`badge bg-${project.badge} ${project.badge === 'warning' ? 'text-dark' : ''}`}>{project.level}</span>
                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </Container>
        </section> */}
      </div>
    </>
  );
}

export default App;
